spliceOne